(() => {
  const bind = video => {
    if (video.dataset.lsgBound) return;
    const container = video.closest('.lsg-hero-media');
    const button = container?.querySelector('[data-lsg-video-toggle]');
    const fallback = container?.querySelector('[data-lsg-motion-fallback]');
    if (!button || !fallback) return;
    video.dataset.lsgBound = 'true';
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.autoplay = true;
    video.loop = true;
    video.controls = false;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let userPaused = false;
    let userAllowsMotion = false;
    let visible = true;
    let usingFallback = false;
    let fallbackPlaying = false;
    let starting = false;
    const allowed = () => video.isConnected && !document.hidden && visible &&
      !userPaused && (!reduced.matches || userAllowsMotion);
    const isPlaying = () => usingFallback ? fallbackPlaying : !video.paused;
    const sync = () => {
      const playing = isPlaying();
      const label = playing ? button.dataset.pause : button.dataset.play;
      button.classList.toggle('is-playing', playing);
      button.setAttribute('aria-label', label);
      button.querySelector('span').textContent = label;
      button.hidden = !usingFallback && video.readyState < 2 && !reduced.matches;
    };
    const syncFallback = () => {
      fallbackPlaying = allowed();
      const src = fallbackPlaying ? fallback.dataset.animatedSrc : video.poster;
      if (fallback.getAttribute('src') !== src) fallback.src = src;
      sync();
    };
    const useFallback = () => {
      usingFallback = true;
      video.pause();
      video.hidden = true;
      fallback.hidden = false;
      syncFallback();
    };
    const pause = () => {
      video.pause();
      if (usingFallback) syncFallback();
      sync();
    };
    const start = () => {
      if (!allowed()) { pause(); return; }
      if (usingFallback) { syncFallback(); return; }
      if (!video.paused || starting) { sync(); return; }
      starting = true;
      video.muted = true;
      Promise.resolve(video.play()).catch(error => {
        if (error.name !== 'AbortError' && allowed()) useFallback();
      }).finally(() => { starting = false; sync(); });
    };

    button.addEventListener('click', () => {
      userPaused = isPlaying();
      if (userPaused) pause();
      else { userAllowsMotion = true; start(); }
    });
    video.addEventListener('loadeddata', start);
    video.addEventListener('canplay', start);
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    video.addEventListener('error', useFallback);
    document.addEventListener('visibilitychange', () => document.hidden ? pause() : start());
    window.addEventListener('pageshow', start);
    reduced.addEventListener('change', () => { userAllowsMotion = false; start(); });

    const films = Array.from(document.querySelectorAll('.lsg-film video'));
    films.forEach(film => film.addEventListener('play', () => {
      films.forEach(other => { if (other !== film) other.pause(); });
      video.pause();
      sync();
    }));
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        if (visible) {
          if (!userPaused) films.forEach(film => film.pause());
          start();
        } else pause();
      }, { threshold: 0.12 });
      observer.observe(container);
    }
    start();
    sync();
  };
  const init = () => document.querySelectorAll('[data-lsg-hero-video]').forEach(bind);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
